import React from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import ButtonBase from '../../../components/Buttons/ButtonBase';

export default props => {
  const {
    isValid,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    touched,
    errors
    // setTouched,
    // dirty,
  } = props;

  const handleChangeMultiple = field => event => {
    event.preventDefault();
    // setFieldValue: (field: string, value: any, shouldValidate?: boolean)
    let value = event.target.value;
    setFieldValue(field, value);
  };

  return (
    <form>
      <Grid
        container
        direction="column"
        justify="center"
        alignItems="center"
        item
      >
        <TextField
          variant="outlined"
          label="Nombre del despacho*"
          type="text"
          id="officeName"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.officeName}
          helperText={
            touched.officeName && errors.officeName ? errors.officeName : ''
          }
          error={touched.officeName && errors.officeName ? true : false}
        />

        <TextField
          variant="outlined"
          label="Nombre del titular*"
          type="text"
          id="name"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.name}
          helperText={touched.name && errors.name ? errors.name : ''}
          error={touched.name && errors.name ? true : false}
        />

        <TextField
          className="classes.textFormat"
          label="Apellido paterno del titular*"
          type="text"
          id="firstLastName"
          variant="outlined"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.firstLastName}
          helperText={
            touched.firstLastName && errors.firstLastName
              ? errors.firstLastName
              : ''
          }
          error={touched.firstLastName && errors.firstLastName ? true : false}
        />

        <TextField
          label="Apellido materno del titular*"
          type="text"
          id="secondLastName"
          variant="outlined"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.secondLastName}
          helperText={
            touched.secondLastName && errors.secondLastName
              ? errors.secondLastName
              : ''
          }
          error={touched.secondLastName && errors.secondLastName ? true : false}
        />

        {/* <MultipleSelect
          handleBlur={handleBlur}
          handleChange={handleChangeMultiple('specialties')}
          specialties={values.specialties}
          touchedSpecialty={touched.specialties}
          errorsSpecialty={errors.specialties}
        /> */}
      </Grid>

      <div className="horizontal-layout margin-top-20">
        <ButtonBase
          type="submit"
          onClick={handleSubmit}
          variant="primary"
          disabled={!isValid}
        >
          Continuar
        </ButtonBase>
      </div>
    </form>
  );
};
